/**
 * Elegir qué justificar cuando el día admite más de un tipo (008 · T111; contracts/ui.md §2.2):
 * bottom sheet con una opción por tipo ("Tardanza · 12 min", "Salida anticipada · 20 min"). Los
 * tipos y sus minutos vienen del servidor (`justify.kinds` y la evaluación del día).
 */
import type { JustificationKind, StaffDay } from '@fermin/contracts';

import { Button } from '../../components/ui/button';
import { Sheet } from '../../components/ui/sheet';
import { t } from '../../i18n';

import { kindWithMinutes, observedMinutesOf } from './labels';

export interface KindSheetProps {
  open: boolean;
  day: StaffDay;
  onChoose: (kind: JustificationKind) => void;
  onClose: () => void;
}

export function KindSheet({ open, day, onChoose, onClose }: KindSheetProps) {
  return (
    <Sheet
      open={open}
      onClose={onClose}
      title={t('justification.kindSheet.title')}
      description={t('justification.kindSheet.description')}
      className="pb-fm-4"
      footer={
        <div data-testid="justify-kind-sheet" className="flex flex-col gap-fm-3">
          {day.justify.kinds.map((kind) => (
            <Button
              key={kind}
              data-testid={`justify-kind-${kind}`}
              variant="secondary"
              onClick={() => onChoose(kind)}
            >
              {kindWithMinutes(kind, observedMinutesOf(day, kind))}
            </Button>
          ))}
          <Button variant="ghost" onClick={onClose}>
            {t('justification.kindSheet.back')}
          </Button>
        </div>
      }
    />
  );
}
